/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_LoginInputs */

const en_action_login = /** @type {(inputs: Action_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign In`)
};

const id_action_login = /** @type {(inputs: Action_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk`)
};

/** @type {(inputs: Action_LoginInputs) => LocalizedString} */
const es_action_login = en_action_login;

/** @type {(inputs: Action_LoginInputs) => LocalizedString} */
const fr_action_login = en_action_login;

/** @type {(inputs: Action_LoginInputs) => LocalizedString} */
const de_action_login = en_action_login;

/** @type {(inputs: Action_LoginInputs) => LocalizedString} */
const ja_action_login = en_action_login;

/** @type {(inputs: Action_LoginInputs) => LocalizedString} */
const zh_action_login = en_action_login;

/** @type {(inputs: Action_LoginInputs) => LocalizedString} */
const ar_action_login = en_action_login;

/** @type {(inputs: Action_LoginInputs) => LocalizedString} */
const it_action_login = en_action_login;

/** @type {(inputs: Action_LoginInputs) => LocalizedString} */
const ru_action_login = en_action_login;

/** @type {(inputs: Action_LoginInputs) => LocalizedString} */
const pt_action_login = en_action_login;

/** @type {(inputs: Action_LoginInputs) => LocalizedString} */
const ko_action_login = en_action_login;

/**
* | output |
* | --- |
* | "Sign In" |
*
* @param {Action_LoginInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_login = /** @type {((inputs?: Action_LoginInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_LoginInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_login(inputs)
	if (locale === "es") return es_action_login(inputs)
	if (locale === "fr") return fr_action_login(inputs)
	if (locale === "de") return de_action_login(inputs)
	if (locale === "ja") return ja_action_login(inputs)
	if (locale === "zh") return zh_action_login(inputs)
	if (locale === "ar") return ar_action_login(inputs)
	if (locale === "id") return id_action_login(inputs)
	if (locale === "it") return it_action_login(inputs)
	if (locale === "ru") return ru_action_login(inputs)
	if (locale === "pt") return pt_action_login(inputs)
	return ko_action_login(inputs)
});